module.exports = __webpack_public_path__ + "static/media/banner002.9ec3fae7.jpg";